/**
 * Formatação de duração, compartilhada pelo controle do cabeçalho e pelas
 * telas de jornada.
 *
 * Ficou em arquivo próprio porque a mesma conta apareceria em três lugares, e
 * função de quatro linhas copiada é onde as versões divergem sem ninguém ver:
 * uma arredonda para cima, a outra trunca, e o mesmo turno passa a mostrar
 * "7h 59m" numa tela e "8h" na outra.
 */

/** `27180` vira `7h 33m`. Abaixo de uma hora, mostra minutos; abaixo de um
 *  minuto, mostra segundos — senão um turno recém-aberto exibe "0m" e parece
 *  travado. */
export function formatarDuracao(segundos) {
  const total = Math.max(0, Math.floor(Number(segundos) || 0));

  const horas = Math.floor(total / 3600);
  const minutos = Math.floor((total % 3600) / 60);

  if (horas > 0) return `${horas}h ${String(minutos).padStart(2, '0')}m`;
  if (minutos > 0) return `${minutos}m`;
  return `${total}s`;
}

/** Quanto tempo passou desde uma data, em segundos. Data inválida vira zero. */
export function segundosDesde(quando) {
  if (!quando) return 0;
  const inicio = new Date(quando).getTime();
  if (Number.isNaN(inicio)) return 0;
  return Math.max(0, Math.floor((Date.now() - inicio) / 1000));
}
